(function ($, root, undefined) {

    'use strict';

    function improveIban() {
        let iban = $(this).val();
        if (iban.length > 10) {
            iban = iban.toUpperCase().replace(/[^A-Z0-9]/g, '');
            $(this).val(iban)
        }
    }

    function improvePhone() {
        let phone = $(this).val();
        if (phone.length > 10) {
            phone = phone.replace(/[^0-9]/g, '');
            $(this).val(phone)
        }
    }


    /*
     *      DOCUMENT READY
     */

    jQuery(document).ready(function () {

        jQuery(document).on('keyup', '.gfield.iban input', improveIban);
        jQuery(document).on('keyup', '.gfield.phone input', improvePhone);

    })

})(jQuery, this);